import { Component, OnInit } from '@angular/core';
import { ODLErrorMessages, EventAddCommessa, EventAddOrdine, BatchOperation } from '../def/types';
import { RecursiveCommessa, Commessa, OrdineLavoro } from '../def/structures';
import { Router } from '@angular/router';
import { DBFirestoreService } from '../dbfirestore.service';

@Component({
    selector: 'app-odl-addnew',
    templateUrl: './odl-addnew.component.html',
    styleUrls: ['./odl-addnew.component.scss']
})
export class OdlAddnewComponent implements OnInit {

    public addnew = true;
    public recursive_commessa: RecursiveCommessa;

    constructor(
        private router: Router,
        private db: DBFirestoreService,
    ) { }

    ngOnInit() {
        this.recursive_commessa = {
            commessa: <Commessa>{
                data_ricezione: new Date()
            },
            ordini: []
        }
    }

    onCreate(eventUpdate: EventAddCommessa) {

        const commessa: Partial<Commessa> = eventUpdate.data;
        const eventoOrdini: EventAddOrdine[] = eventUpdate.ordini;

        if ( !commessa.data_ricezione || (commessa.data_ricezione.getFullYear() < 2000) || (commessa.data_ricezione.getFullYear() > 2099) ) {
            alert('La data non corretta.');
            return;
        }

        if ( !commessa.cliente) {
            alert('Per favore, il campo cliente.');
            return;
        }

        if ( !eventoOrdini.length ) {
            alert('Non è stato selezionato nessun giorno.');
            return;
        }
        const new_commessa: Commessa = {
            id : this.db.createId(),
            data_ricezione: commessa.data_ricezione,
            cliente: commessa.cliente || '',
            indirizzo: commessa.indirizzo || '',
            localita: commessa.localita || '',
            telefono: commessa.telefono || '',
            numero_ordini : eventoOrdini.length,
            persona_riferimento: commessa.persona_riferimento || '',
            tipo_intervento: commessa.tipo_intervento || null,
            tipo_cliente: commessa.tipo_cliente || null,
            note: commessa.note || '',
            utente: commessa.utente || null,
        }

        const ops: BatchOperation[] = [];

        ops.push(this.db.batchSetCommessa(new_commessa));

        eventoOrdini.forEach(eventOrdine => {

            // Per eseguire inserimento in modalità batch è necessario fornire manualmente un id
            const pseudoId = new_commessa.id + '-' +
                eventOrdine.date.getFullYear().toString() +
                (eventOrdine.date.getMonth() + 1).toString().padStart(2, '0') +
                eventOrdine.date.getDate().toString().padStart(2, '0');

            const defaultValues = eventOrdine.default || {};

            const doc: OrdineLavoro = {
                id: pseudoId,
                confermato: false,
                durata_prevista: '',
                giorno_ora: eventOrdine.date,
                attrezzi: '',
                indirizzo: defaultValues.indirizzo || '',
                localita: defaultValues.localita || '',
                note: defaultValues.note || '',
                persona_riferimento: defaultValues.persona_riferimento || '',
                autista: null,
                caposquadra: null,
                mezzo: null,
                telefono: defaultValues.telefono || '',
                rif_commessa: new_commessa.id,

                tipo_cliente: new_commessa.tipo_cliente ? new_commessa.tipo_cliente.id : null,
                tipo_intervento: new_commessa.tipo_intervento ? new_commessa.tipo_intervento.id : null,
            };
            ops.push(this.db.batchAddOrdine(doc));

        });

        this.db.batch(ops).then(() => {
            this.router.navigate(['/schedule']);
        }).catch(error => {
            this.onError({ title: 'Errore aggiornamento', details: error });
        })
        
        if ( !this.db.online ) {
            this.router.navigate(['/schedule']);
        }

    }

    onCancel(ask_confirm:boolean=false) {
        const confirmed: boolean = ask_confirm ? confirm('Uscire senza salvare?') : true;
        if (confirmed) {
            this.router.navigate(['/schedule']);
        }
    }

    onError(error: ODLErrorMessages) {
        alert(error.title)
    }

}
